import { AxiosRequestConfig } from 'axios'

import { CreateEventPayload, UpdateEventPayload } from './types'

const getEvent = (): AxiosRequestConfig => ({
  url: '/events',
  method: 'GET',
})

const getEvents = (): AxiosRequestConfig => ({
  url: '/events/all',
  method: 'GET',
})

const createEvent = (data: CreateEventPayload): AxiosRequestConfig => ({
  url: '/events',
  method: 'POST',
  data,
})

const updateEvent = ({ id, ...data }: UpdateEventPayload): AxiosRequestConfig => ({
  url: `/events/${id}`,
  method: 'PUT',
  data,
})

export { createEvent, getEvent, getEvents, updateEvent }
